import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CandidatesList from './pages/CandidatesList';
import CandidateDetails from './pages/CandidateDetails';
import RecruitersList from './pages/RecruitersList';
import RecruiterDetails from './pages/RecruiterDetails';
import NewJobOffer from './pages/NewJobOffer';
import EditJobOffer from './pages/EditJobOffer';
import MissionsList from './pages/MissionsList';
import NewMission from './pages/NewMission';
import PacksList from './pages/PacksList';
import MessagesList from './pages/MessagesList';
import NewAdmin from './pages/NewAdmin';
import AdminsList from './pages/AdminsList';
import ReviewsList from './pages/ReviewsList';
import MissionApplicationsList from './pages/MissionApplicationsList';
import PackRequests from './pages/PackRequests';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/candidates" element={<CandidatesList />} />
            <Route path="/candidates/:id" element={<CandidateDetails />} />
            <Route path="/recruiters" element={<RecruitersList />} />
            <Route path="/recruiters/:id" element={<RecruiterDetails />} />
            <Route path="/recruiters/:id/new-offer" element={<NewJobOffer />} />
            <Route path="/job-offers/:id/edit" element={<EditJobOffer />} />
            <Route path="/missions" element={<MissionsList />} />
            <Route path="/missions/new" element={<NewMission />} />
            <Route path="/mission-applications" element={<MissionApplicationsList />} />
            <Route path="/packs" element={<PacksList />} />
            <Route path="/messages" element={<MessagesList />} />
            <Route path="/reviews" element={<ReviewsList />} />
            <Route path="/admins" element={<AdminsList />} />
            <Route path="/admins/new" element={<NewAdmin />} />
            <Route path="/pack-requests" element={<PackRequests />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
